export function openQuickSearch() {
    gd.modals.other.showMagicSearch()
}